import React, { useEffect } from "react";
import { useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import PropTypes from "prop-types";
import "../client-dashboard/clientDashboardMap.css";
import "leaflet.heat";
import HeatmapOverlay from "leaflet-heatmap";

import { checkShapefileAvailability, fetchPreprocessedOrgRanges } from "./lightningData";

export async function heatMapData() {
  const shapefileOk = await checkShapefileAvailability();
  if (!shapefileOk) {
    console.warn("Shapefile not available. Heatmap will be empty.");
    return [];
  }

  const data = await fetchPreprocessedOrgRanges();
  if (!data) {
    console.warn("No preprocessed lightning data available.");
    return [];
  }

  return Array.from(data.entries())
    .map(([key, count]) => {
      try {
        const range = JSON.parse(key);
        const midLat = (range[0][0] + range[2][0]) / 2;
        const midLon = (range[0][1] + range[2][1]) / 2;
        return [midLon, midLat, count];
      } catch {
        console.warn("Failed to parse range key JSON:", key);
        return null;
      }
    })
    .filter(Boolean);
}

export const HeatMapLayer = ({ data, onExtremaChange }) => {
  const map = useMap();

  useEffect(() => {
    if (!map) return;

    const cfg = {
      radius: 0.125,
      maxOpacity: 0.7,
      minOpacity: 0.1,
      scaleRadius: true,
      useLocalExtrema: true,
      latField: "lat",
      lngField: "lng",
      valueField: "count",
      onExtremaChange: (data) => {
        onExtremaChange(data.min, data.max);
      },
    };

    const heat = new HeatmapOverlay(cfg);
    heat.setData({
      max: Math.max(...data.map(d => d[2])),
      data: data.map(([lat, lng, count]) => ({ lat, lng, count })),
    });

    map.addLayer(heat);
    return () => {
      map.removeLayer(heat);
    };
  }, [map, data, onExtremaChange]);

  return null;
};

HeatMapLayer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number)).isRequired,
  onExtremaChange: PropTypes.func.isRequired,
};